import { Button, Spinner } from 'react-bootstrap';

export default function SubmitButton({ loading, disabled = false, text, ...rest }) {
    return (
        <Button
            disabled={loading || disabled}
            {...rest}
        >
            {loading ? (
                <Spinner as="span" animation="border" role="status" aria-hidden="true" variant="light" size="sm" />
            ) : (
                <span>
                    {text}
                </span>
            )}
        </Button>
    );
}